import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import './SlidingNavbar.css'

const SlidingNavbar = ({catName}) => {

  const slidingNavContainerRef = useRef(null);

  useEffect(() => {
    const lowerCaseCatName = catName.toLowerCase(); // Ignore case
    switch (lowerCaseCatName) {
      case 'supper dishes':
        handleScrollToSelectedItem(0)
        break;
      case 'puddings':
        handleScrollToSelectedItem(1)
        break;
      default:
        handleScrollToSelectedItem(0)
      break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScrollToSelectedItem = (index) => {
    if (slidingNavContainerRef.current) {
      const slidingNavContainer = slidingNavContainerRef.current;
      const selectedItem = slidingNavContainer.children[index];
      const containerWidth = slidingNavContainer.offsetWidth;
      const selectedItemWidth = selectedItem.offsetWidth;
      const selectedItemLeftOffset = selectedItem.offsetLeft;

      const scrollOffset = selectedItemLeftOffset - containerWidth / 2 + selectedItemWidth / 2;
      slidingNavContainer.scrollLeft = scrollOffset;
    }
  };

  return (
    <div className='sliding_nav_wrapper'>
    <ul className='sliding_nav_container' ref={slidingNavContainerRef}>
      <li className={'sliding_nav_item'}>
        <Link
          to='/market/supper-dishes'
          className='sliding_nav_link'
          onClick={() => {
            window.scroll(0, 0);
            handleScrollToSelectedItem(0);
          }}
        >
          SUPPER DISHES
        </Link>
      </li>
      {/*<li className={'sliding_nav_item'}>*/}
      {/*  <Link*/}
      {/*    to='/market/side-dishes'*/}
      {/*    className='sliding_nav_link'*/}
      {/*    onClick={() => {*/}
      {/*      window.scroll(0, 0);*/}
      {/*      handleScrollToSelectedItem(1);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    SIDE DISHES*/}
      {/*  </Link>*/}
      {/*</li>*/}
      {/*<li className={'sliding_nav_item'}>*/}
      {/*  <Link*/}
      {/*    to='/market/buffet-dishes'*/}
      {/*    className='sliding_nav_link'*/}
      {/*    onClick={() => {*/}
      {/*      window.scroll(0, 0);*/}
      {/*      handleScrollToSelectedItem(1);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    BUFFET DISHES*/}
      {/*  </Link>*/}
      {/*</li>*/}
      <li className={'sliding_nav_item'}>
        <Link
          to='/market/puddings'
          className='sliding_nav_link'
          onClick={() => {
            window.scroll(0, 0);
            handleScrollToSelectedItem(1);
          }}
        >
          PUDDINGS
        </Link>
      </li>
      {/*<li className={'sliding_nav_item'}>*/}
      {/*  <Link*/}
      {/*    to='/market/finger-food'*/}
      {/*    className='sliding_nav_link'*/}
      {/*    onClick={() => {*/}
      {/*      window.scroll(0, 0);*/}
      {/*      handleScrollToSelectedItem(3);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    FINGER FOOD*/}
      {/*  </Link>*/}
      {/*</li>*/}
      {/*<li className={'sliding_nav_item'}>*/}
      {/*  <Link*/}
      {/*    to='/market/specials'*/}
      {/*    className='sliding_nav_link'*/}
      {/*    onClick={() => {*/}
      {/*      window.scroll(0, 0);*/}
      {/*      handleScrollToSelectedItem(5);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    SPECIALS*/}
      {/*  </Link>*/}
      {/*</li>*/}
    </ul>
    </div>
  )
}

export default SlidingNavbar